














































import Component from 'vue-class-component'
import Vue from 'vue'
import {
  authServiceUrlOrNull,
  getTokenPayload,
  clearToken,
  login,
} from '@/auth/auth'
import AuthUserService, { AuthUser } from '@/services/AuthUserService'

@Component
export default class UserMenu extends Vue {
  user: AuthUser | null = null

  get canLogout(): boolean {
    return authServiceUrlOrNull() !== null
  }

  get initials(): string {
    if (!this.user) {
      return ''
    }

    return this.user.name
      .split(' ')
      .slice(0, 2)
      .map(word => word.charAt(0))
      .join('')
      .toUpperCase()
  }

  async created() {
    if (!this.canLogout) {
      // Сборка без SSO (локальный докер): бэк отдаёт dev-юзера, меню — заглушка.
      this.user = { name: 'Dev User', caption: 'Developer', avatar: '' }

      return
    }

    try {
      this.user = await AuthUserService.me()
    } catch (e) {
      // SSO-сессии нет/протухла — показываем профиль из payload JWT.
      const payload = getTokenPayload()

      this.user = payload
        ? {
            name: [payload.firstName, payload.lastName]
              .filter(Boolean)
              .join(' '),
            caption: payload.positionName || '',
            avatar: payload.avatar || '',
          }
        : { name: 'Не авторизован', caption: '', avatar: '' }
    }
  }

  async logout() {
    try {
      // Гасим сессию на SSO, иначе get_token тут же выдаст новый токен.
      await AuthUserService.logout()
    } catch (e) {
      // SSO недоступен — локальный токен всё равно чистим и уводим на логин.
    }

    clearToken()
    login()
  }

  onAvatarError() {
    if (this.user) {
      this.user.avatar = ''
    }
  }
}
